exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/my-dream-app/src/app/process-oee-kpis/process-oee-kpis.component.css
// module id = ../../../../../src/app/process-oee-kpis/process-oee-kpis.component.css
// module chunks = main